import * as React from 'react';


class TestReactSelect extends React.Component {
    constructor(props) {
        super(props);
        this.componentName= "[TestReactSelect.jsx] ";
 
        this.state = {
            options: [
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' }
            ]
        }
    }
  
    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <h1>Test React Select</h1>

            </div>
        );
    }
}


export default TestReactSelect;